var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 576 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 32C21.5 32 0 53.5 0 80V144C0 152.9 7.125 160 16 160H96V80C96 53.5 74.5 32 48 32ZM256 380.6V320H480V128C480 75 437 32 384 32H111.6C121.8 45.38 128 61.88 128 80V384C128 422.88 162.62 453.63 202.75 447.13C234.3 442 256 412.5 256 380.6ZM288 352V384C288 436.88 245 480 192 480H464C525.88 480 576 429.87 576 368C576 359.125 568.875 352 560 352H288Z",
    fill: "#4F4F4F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.f7011f224b190b06c61e42954f754d4d.svg";
export { ForwardRef as ReactComponent };